import React from "react";
import { styled, useTheme } from "@mui/material/styles";
import { RenderIf } from "src/components/core";
import { ErrorIcon, SuccessIcon, WarningIcon } from "src/config/mui-theme/overrides/CustomIcons";

const StyledRenderIcon = styled("div")(({ theme, variant }) => ({
  width: 25,
  height: 25,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: theme.palette.common.white,
  color: theme.palette[variant].main,
  padding: 0,
  margin: 0,
  borderRadius: "50%",
}));

const RenderIcon = ({ theme }) => {
  const muiTheme = useTheme();
  return (
    <StyledRenderIcon variant={theme}>
      <RenderIf isTrue={theme === "success"}>
        <SuccessIcon color="primary.success" fill={muiTheme.palette.success.main} />
      </RenderIf>
      <RenderIf isTrue={theme === "error"}>
        <ErrorIcon color="primary.success" fill={muiTheme.palette.error.main} />
      </RenderIf>
      <RenderIf isTrue={theme === "warning"}>
        <WarningIcon color="primary.warning" />
      </RenderIf>
    </StyledRenderIcon>
  );
};

export default RenderIcon;
